export default __webpack_public_path__ + "static/media/4.10060a83.png";